import React from 'react'
import {
  withStyles,
  Grid,
  ListItem,
  ListItemSecondaryAction,
} from '@material-ui/core'
import { BookOpenVariant } from 'mdi-material-ui'
import Menu from '../Menu'
import language from 'utils/vast-languagepack'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { toggleDialog } from 'actions/view'

export default connect(null, dispatch =>
  bindActionCreators({ toggleDialog }, dispatch),
)(
  withStyles(theme => ({
    createdDate: {
      color: theme.palette.secondary.main,
      display: 'inline-block',
    },
    newSecondaryHeading: {
      // fontSize: theme.typography.pxToRem(15),
      backgroundColor: theme.palette.green,
      color: '#fff',
      borderRadius: 10,
      padding: '16px 10px 16px 10px !important',
      marginRight: '10px',
      whiteSpace: 'nowrap',
      [theme.breakpoints.up('xs')]: {
        fontSize: theme.typography.pxToRem(10),
      },
      [theme.breakpoints.up('sm')]: {
        fontSize: theme.typography.pxToRem(12),
      },
      [theme.breakpoints.up('md')]: {
        fontSize: theme.typography.pxToRem(15),
      },
    },
    newThirdHeading: {
      fontSize: theme.typography.pxToRem(15),
      backgroundColor: theme.palette.orange,
      color: '#fff',
      borderRadius: 10,
      padding: '16px 10px 16px 10px !important',
      marginRight: '32px',
      whiteSpace: 'nowrap',
      [theme.breakpoints.up('xs')]: {
        fontSize: theme.typography.pxToRem(10),
      },
      [theme.breakpoints.up('sm')]: {
        fontSize: theme.typography.pxToRem(12),
      },
      [theme.breakpoints.up('md')]: {
        fontSize: theme.typography.pxToRem(15),
      },
    },
    newHeading: {
      fontSize: theme.typography.pxToRem(15),
      fontWeight: 'bold',
      display: 'table',
      tableLayout: 'fixed',
      width: '100%',
      whiteSpace: 'nowrap',
      marginBottom: 5,
    },
    createdHeading: {
      color: theme.palette.text.secondary,
      fontSize: theme.typography.pxToRem(15),
      fontWeight: 'bold',
      display: 'table',
      tableLayout: 'fixed',
      width: '100%',
      whiteSpace: 'nowrap',
    },
    text: {
      display: 'table-cell',
      overflow: 'hidden',
      textOverflow: 'ellipsis',
    },
    expandPanelIconTypography: {
      color: theme.palette.secondary.main,
      fontWeight: 'bold',
      fontSize: '9px',
    },
    expandPanelIcon: {
      color: theme.palette.secondary.main,
      textAlign: 'center',
      marginRight: '15px',
      width: '60px',
      height: '40px',
    },
    listItemButton: {
      '&:hover': {
        backgroundColor: '#C0DEFB',
      },
    },
    container: {
      listStyle: 'none',
      borderBottom: '1px solid #adadad',
      borderRight: '1px solid #adadad',
    },
    dataColors: {
      margin: '20px 0',
      [theme.breakpoints.down('sm')]: {
        margin: '10px 0',
      },
    },
    expandPanelIconInner: {
      position: 'absolute',
      top: '50%',
      left: '50%',
      transform: 'translate(-50%, -50%)',
    },
    heading: {
      fontSize: theme.typography.pxToRem(15),
      fontWeight: 'bold',
      display: 'table',
      tableLayout: 'fixed',
      width: '100%',
      whiteSpace: 'nowrap',
      marginBottom: 5,
    },
    description: {
      color: theme.palette.text.secondary,
      fontSize: theme.typography.pxToRem(15),
      display: 'table',
      tableLayout: 'fixed',
      width: '100%',
      whiteSpace: 'nowrap',
      marginBottom: 5,
    },
    secondaryAction: {
      [theme.breakpoints.up('xs')]: {
        paddingRight: 33,
      },
      [theme.breakpoints.up('md')]: {
        paddingRight: 60,
      },
    },
    secondaryActionRoot: {
      [theme.breakpoints.up('xs')]: {
        top: 'calc(50% - 16px)',
      },
      [theme.breakpoints.up('md')]: {
        top: 'calc(50% - 24px)',
      },
    },
    info: {
      display: 'inline-block',
      // marginLeft: 75,
      // [theme.breakpoints.down('sm')]: {
      //   marginLeft: 68,
      // },
    },
    number: {
      marginRight: 3,
      fontSize: theme.typography.pxToRem(22),
      verticalAlign: 'middle',
    },
    statText: {
      fontSize: theme.typography.pxToRem(9),
      display: 'inline-block',
    },
    stats: {
      whiteSpace: 'nowrap',
      fontWeight: 'bold',
      display: 'inline-block',
      [theme.breakpoints.down('sm')]: {
        width: '100%',
        whiteSpace: 'normal',
      },
    },
    stat: {
      color: '#fff',
      display: 'inline-block',
      borderRadius: '10px',
      padding: '10px',
      textAlign: 'center',
      marginRight: 17,
      whiteSpace: 'nowrap',
      '&:last-child': {
        marginRight: 0,
      },
      [theme.breakpoints.down('sm')]: {
        marginRight: 5,
        '&:last-child': {
          marginRight: 0,
        },
        marginTop: 2,
        padding: 3,
      },
      [theme.breakpoints.down('md')]: {
        marginRight: 6,
        '&:last-child': {
          marginRight: 0,
        },
        padding: 4,
      },
    },
  }))(
    ({ addOrEditPush, knowledge, classes, entityType, size, toggleDialog, isPinned }) => {
      const date = new Date(knowledge.created_date)

      return (
        <ListItem
          key={`formsPageListItem${knowledge.id}`}
          onClick={() => {
            // addOrEditPush(knowledge.id)
            toggleDialog({
              open: true,
              dialog: 'AddOrEditKnowledge',
              options: {
                id: knowledge.id,
              },
            })
          }}
          button
          classes={{
            container: classes.container,
            secondaryAction: classes.secondaryAction,
          }}
        >
          <div className={classes.expandPanelIcon}>
            <BookOpenVariant />
          </div>
          <Grid container className={classes.info}>
            <Grid item md={12} lg={6}>
              <div className={classes.heading}>
                <span className={classes.text}>
                  {isPinned ? '📌 ' : ''}
                  {knowledge?.title || knowledge?.content}
                </span>
              </div>
            </Grid>
            <Grid item xs={12}>
              <div className={classes.createdHeading}>
                <span className={classes.text}>
                  <em>
                    <span>
                      <span>{`${language.task.menuSort.created} `}</span>
                      <span className={classes.createdDate}>
                        {`${date.toLocaleDateString()}`}
                      </span>
                    </span>
                  </em>
                </span>
              </div>
            </Grid>
          </Grid>
          <ListItemSecondaryAction>
            <Menu
              vert
              entityType="knowledge"
              entityName={knowledge.title}
              entityID={knowledge.id}
              addOrEditPush={id => {
                // addOrEditPush(id)
                toggleDialog({
                  open: true,
                  dialog: 'AddOrEditKnowledge',
                  options: {
                    id: knowledge.id,
                  },
                })
              }}
            />
          </ListItemSecondaryAction>
        </ListItem>
      )
    },
  ),
)
